import type { NextPage } from 'next';
import getConfig from 'next/config';
import { useEffect } from 'react';

const { publicRuntimeConfig } = getConfig();

const Home: NextPage = () => {
  useEffect(() => {
    window.location.href = publicRuntimeConfig.AUTH_LOGIN_URL;
  }, []);
  return <></>;
};

export default Home;
